import {Component, Input, OnInit} from '@angular/core';
import {
  CalendarioModificaOption,
  VisualizationCalendarModalEnum
} from "../../enums/calendar-event-titles-enum";
import {ModalFormConfiguration} from "../../interfaces/modal-configuration-interface";
import {ModalRoleEnum} from "../../enums/modal-enum";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonToolbar, IonTitle, IonSegment, IonSegmentButton, IonLabel, IonButton, IonItem, IonInput, IonIcon, IonModal, IonDatetime, IonButtons, ModalController } from '@ionic/angular/standalone';
import {format, parse, isBefore, isEqual} from "date-fns";
import {finalize, of, switchMap, takeUntil, tap, throwError} from "rxjs";
import {LoaderService} from "../../../services/loader.service";
import {UnsubscribeOnDestroy} from "../../abstracts/unsubscribe-on-destroy";
import {ManageErrorService, RequestTypesEnum} from "../../../services/manage-error.service";
import { HttpErrorResponse } from "@angular/common/http";

import {
  ServizioMensaEventoCalendarioForm,
  ServizioMensaEventoCalendarioType,
  StudenteCittadinoDettaglioService
} from "../../../core/api/generated";
import {ServiziAttiviService} from "../../../services/pratiche/servizi-attivi.service";
import {NotificationService} from "../../../services/notification.service";
import { UpperCasePipe, DatePipe } from '@angular/common';
import {TranslocoModule, TranslocoService, provideTranslocoScope} from '@jsverse/transloco';


@Component({
    selector: 'app-choose-calendar-event-modal',
    templateUrl: './choose-calendar-event-modal.component.html',
    styleUrls: ['./choose-calendar-event-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonSegment, IonSegmentButton, IonLabel, IonButton, IonItem, IonInput, IonIcon, IonModal, IonDatetime, IonButtons, FormsModule, ReactiveFormsModule, UpperCasePipe, DatePipe, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class ChooseCalendarEventModalComponent extends UnsubscribeOnDestroy implements OnInit {
  visualizzazione = VisualizationCalendarModalEnum;
  currentSegment: VisualizationCalendarModalEnum = VisualizationCalendarModalEnum.PASTA_IN_BIANCO;
  currentDay: string = '';
  todayDate: string | undefined;
  ctrlAssenzaInizio: FormControl = new FormControl();
  ctrlAssenzaFine: FormControl = new FormControl();
  currentStudenteId: string = '';
  currentDate: string | undefined;

  // Stringhe da scope Transloco lazy ('shared'): risolte a render-time via getter, così la
  // prima apertura del modale mostra il testo tradotto invece della chiave grezza (lo scope
  // può non essere ancora caricato durante l'init). Vedi spec i18n-foundation.
  get modalMessagePasta(): string {
    return this.transloco.translate('shared.choose_calendar_event.messagePasta', { data: this.currentDay });
  }
  get messageDateAssenza(): string {
    return this.transloco.translate('shared.choose_calendar_event.messageAssenza');
  }
  get confirmButtonText(): string {
    return this.transloco.translate('common.action.confirm');
  }
  get cancelButtonText(): string {
    return this.transloco.translate('common.action.cancel');
  }
  get errorMessageDate(): string {
    return this.transloco.translate('shared.choose_calendar_event.errorDate');
  }

  @Input() set day(day: string) {
    this.currentDay = day;
  }

  @Input() set idStudente(idStudente: string) {
    this.currentStudenteId = idStudente;
  }

  @Input() segmentoIniziale?: VisualizationCalendarModalEnum;
  @Input() dataFineOverride?: string;

  constructor(private modalController: ModalController,
              private loaderService: LoaderService,
              private manageErrorService: ManageErrorService,
              private studenteControllerService: StudenteCittadinoDettaglioService,
              private serviziAttivi: ServiziAttiviService,
              private notificationService: NotificationService,
              private transloco: TranslocoService) {
    super();
  }

  ngOnInit() {
    this.todayDate = format(new Date(), "yyyy-MM-dd");
    this.currentDate = format(parse(this.currentDay, 'dd/MM/yyyy', new Date()), "yyyy-MM-dd");
    this.ctrlAssenzaInizio.setValue(this.currentDate);
    this.ctrlAssenzaFine.setValue(this.dataFineOverride ?? this.currentDate);

    if (this.segmentoIniziale) {
      this.currentSegment = this.segmentoIniziale;
    }
  }

  segmentVisualizationChanged($event: any) {
    console.log('SEGMENT CHANGE', $event.detail.value);
    this.currentSegment = $event.detail.value;
  }

  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirmPasta() {
    const options: CalendarioModificaOption = {
      tipoEvento: ServizioMensaEventoCalendarioType.PASTA_IN_BIANCO,
      giorni: [this.currentDay]
    };
    this.modificaCalendarioConfirm(options)

  }

  confirmAssenza() {
    const inizio = parse(this.ctrlAssenzaInizio.value, 'yyyy-MM-dd', new Date());
    const fine = parse(this.ctrlAssenzaFine.value, 'yyyy-MM-dd', new Date());
    if (isBefore(inizio, fine) || isEqual(inizio, fine)) {
      const giornoInizio = format(inizio, 'dd/MM/yyyy');
      const giornoFine = format(fine, 'dd/MM/yyyy');
      const options: CalendarioModificaOption = {
        tipoEvento: ServizioMensaEventoCalendarioType.ASSENZA,
        giorni: [giornoInizio, giornoFine]
      };
      //this.modificaCalendarioConfirm()
      this.modificaCalendarioConfirm(options)
    } else {
      this.notificationService.openToast({
        message: this.errorMessageDate,
        color: 'danger'
      })
    }
  }

  modificaCalendarioConfirm(value: CalendarioModificaOption) {
    this.loaderService.showLoaderObserve$().pipe(
      switchMap(() => {
          if (value.tipoEvento === ServizioMensaEventoCalendarioType.ASSENZA) {
            return this.addEventoCalendario$(value,
              ServizioMensaEventoCalendarioType.ASSENZA
            )
          } else if (value.tipoEvento === ServizioMensaEventoCalendarioType.PASTA_IN_BIANCO) {
            return this.addEventoCalendario$(value,
              ServizioMensaEventoCalendarioType.PASTA_IN_BIANCO)
          } else {
            return of(null)
          }
        }
      ),
      takeUntil(this.destroy$),
      finalize(() => this.loaderService.hideLoader())
    ).subscribe({
      next: (value) => {
        this.loaderService.hideLoader();
        return this.modalController.dismiss(value, ModalRoleEnum.CONFIRM);
      }, error: (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.openToast({
          message: error.error.message, color: 'danger'
        })
      }
    });
  }

  addEventoCalendario$(option: CalendarioModificaOption, eventoType: ServizioMensaEventoCalendarioType) {
    const isOptionGiorniPresent = (eventoType !== ServizioMensaEventoCalendarioType.PASTA_IN_BIANCO);
    const data_inizio = isOptionGiorniPresent ? option.giorni![0]! : this.currentDay!;
    const data_fine = isOptionGiorniPresent ? option.giorni!.at(-1)! : this.currentDay!;
    const body: ServizioMensaEventoCalendarioForm = {
      data_inizio: data_inizio,
      data_fine: data_fine,
      tipo_evento: eventoType,
    }
    // L'API per-servizio (`addEventoCalendario1`) richiede l'header `Gestione-Mense-Servizio-Id`:
    // lo si risolve dall'istanza mensa attiva (la modale è globale, non per-pagina). Vedi change
    // `riallinea-client-api-be-baseline`.
    return this.serviziAttivi.idServizioMensaAttivo$().pipe(
      switchMap((idServizio) => idServizio
        ? this.studenteControllerService.addEventoCalendarioStudenteCittadino({
            idStudente: this.currentStudenteId,
            gestioneMenseServizioId: idServizio,
            servizioMensaEventoCalendarioForm: body,
          })
        : throwError(() => new Error('Servizio mensa attivo non disponibile'))),
    );
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
